//  Helpers for continuing the home timeline where the user stopped reading
//  (settings.home.restorePosition, see actions/markers.js and actions/timelines.js).

//  Bottom edge of the column header; posts above it are hidden behind it.
const headerBottom = (column) => {
  const header = column.querySelector(".column-header__wrapper, .column-header");
  return header ? header.getBoundingClientRect().bottom : 0;
};

//  The id of the first post in `column` that is at least partly visible below the header.
//  These are timeline item ids (for boosts the id of the boost), the same ids the API uses
//  for pagination and markers.
export function topVisibleStatusId(column) {
  if (!column) {
    return null;
  }

  const limit = headerBottom(column);
  const articles = column.querySelectorAll("article[data-id]");

  for (const article of articles) {
    if (article.getBoundingClientRect().bottom > limit + 1) {
      return article.getAttribute("data-id");
    }
  }

  return null;
}

const scrollParent = (element) => {
  for (let node = element.parentElement; node; node = node.parentElement) {
    const overflow = getComputedStyle(node).overflowY;
    if ((overflow === "auto" || overflow === "scroll") && node.scrollHeight > node.clientHeight) {
      return node;
    }
  }
  return document.scrollingElement || document.documentElement;
};

//  Scrolls `column` so the post `id` sits right below the header. The post may not be
//  rendered yet, so this retries for a few seconds.
export function scrollToStatus(column, id, timeout = 4000) {
  if (!column || !id) {
    return;
  }

  const started = Date.now();

  const attempt = () => {
    const article = column.querySelector(`article[data-id="${CSS.escape(id)}"]`);

    if (!article) {
      if (Date.now() - started < timeout) {
        setTimeout(attempt, 150);
      }
      return;
    }

    const parent = scrollParent(article);
    parent.scrollTop += article.getBoundingClientRect().top - headerBottom(column) - 4;
  };

  attempt();
}
